import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  map
} from 'rxjs/operators';

import {
  User
} from '../models';

import {
  getAuthHeaders
} from '../app/app.utils';

import {
  _SERVER_URL
} from '../app/app.const';

@Injectable()
export class AuthService {
  public authToken: string;
  
  constructor(
    private http: HttpClient
  ) {}
  
  public getAll(): (
    Promise<User[]>
  ) {
    const deactivatedSuffix = ' (Deactivated)';

    return (
      <any>(
        this.http
            .get<User[]>(
              `${_SERVER_URL}api/users`,
              getAuthHeaders(
                this.authToken
              )
            )
            .pipe(
              map(
                (
                  users: User[]
                ) => (
                  users
                      .map(
                        user => ({
                          ...user,
                          organisation: (
                            (
                              (
                                user
                                  .isActive
                              ) ||
                              (
                                user
                                  .organisation
                                  .endsWith(
                                    deactivatedSuffix
                                  )
                              )
                            ) ?
                              (
                                user
                                .organisation
                              ) :
                              (
                                `${(
                                  user
                                    .organisation
                                )} (Deactivated)`
                              )
                          )
                        })
                      )
                )
              )
            )
            .toPromise()
      )
    );
  }
}
